import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Project",
  "Payment Date",
  "Payment Amount",
  "Payment Mode",
  "Actions",
];
const tableHeadClient = [
  "Sr.",
  "Payment Date",
  "Payment Amount",
  "Payment Mode",
  "Actions",
];
const PaymentTrackingTable = ({ PT = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);

  const goToView = (id) => {
    navigate(`/client-payment-tracking/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {store.Role === process.env.REACT_APP_ROLE_CLIENT
              ? tableHeadClient?.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })
              : tableHead?.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })}
          </tr>
        </thead>
        <tbody>
          {PT?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                  <td>{item?.projectClientName || "N/A"}</td>
                )}
                <td>{item?.paymentDate || "N/A"}</td>
                <td>{item?.paymentAmount || "N/A"}</td>
                <td>{item?.paymentMode || "N/A"}</td>

                <td>
                  <CustomViewButton onClick={() => goToView(item.id)}></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentTrackingTable;
